module.exports = "/_next/static/images/aboutditu-71cfc323b2cfaf70ab8ff6a7e621b61c.png";